export const centerAbsolute = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
} as const;

export const centerAbsoluteX = {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
} as const;

export const centerAbsoluteY = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
} as const;
